























import { defineComponent } from "@vue/composition-api";
import Expandable from "@/components/Expandable.vue";
import { BlockLabel } from "@/models/BlockLabel";

export default defineComponent({
  name: "ConflictfundMembershipDiscount",
  components: {
    Expandable,
  },
  props: {
    blockId: {
      type: Number,
      required: true,
    },
    isExpanded: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      displayName: BlockLabel.ConflictfundMembershipDiscount,
      discount: 0,
    };
  },
  mounted() {
    if (this.data) {
      this.discount = this.data.discount;
    }
  },
  methods: {
    expandBlock() {
      this.$emit("setBlockExpanded", this.blockId);
    },
    collapseBlock() {
      this.$emit("updateBlock", {
        blockId: this.blockId,
        type: this.$options.name,
        discount: this.discount,
      });
    },
  },
});
